/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import MainPage from '../../MainPage';
import { NewRefreshIcon, AddIcon } from '../Common/Icons';
import './Groups.less';
import ListItem from './ListItem';
import { message, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePicUrl, getName } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import {
  PhotoResolution,
  GroupModalActions,
} from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import NewCustomButton from '../Common/NewCustomButton';

const GroupsList = ({
  parentBread,
  setShowGroupModal,
  onActionClick,
  onGroupModalActionClick,
  action = null,
  refreshGroupList = false,
  isStaffAdmin,
}) => {
  const header = parentBread || [];
  const [userGroups, setUserGroups] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const resourcesMap = useSelector(getProfilePics());
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);
  const trans = useSelector(translator);
  const sortedUserGroups = useMemo(() => {
    if (!userGroups || userGroups.length === 0) return [];
    const validGroups = userGroups.filter((group) => group.name && group.name.trim() !== '');
    return validGroups.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  }, [userGroups, refreshCounter, action, refreshGroupList]);

  useEffect(() => {
    setLoading(true);
    // API callback definitions.
    const errorCallback = (error) => {
      // message.error("Error fetching user group !");
      console.error('Error fetching user group:', error);
    };
    const successCallback = (data) => {
      setLoading(false);
      if (data && data.usergroups) {
        setUserGroups(data.usergroups);
      }
    };

    try {
      userGroupApi.getUserGroups(
        {},
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  }, [refreshCounter, action, refreshGroupList]);

  const getInviteContacts = (invitedContacts) => {
    return invitedContacts?.map((contact) => {
      const url = getProfilePicUrl(contact.useruuid, resourcesMap, PhotoResolution.R64);
      const name = getName(contact.useruuid);
      return { profile_image_url: url, name, useruuid: contact.useruuid };
    });
  };

  return (
    <MainPage hasSider={true} header={header}>
      <div className="listgroup-wrapper page-content-wrapper">
        <div className="page-header-container">
          <div className="page-header">
            <span>{trans('GROUPS')}</span>
            <div className="form-button">
              <NewCustomButton
                className="cancel"
                onClick={() => {
                  setRefreshCounter((prev) => prev + 1);
                }}
                label={trans('REFRESH')}
                icon={<NewRefreshIcon className="cancel-icon" />}
              />
            </div>
          </div>
        </div>

        <div className="content-header">
          <div style={{ display: 'flex', 'justify-content': 'flex-start', padding: '10px 0 10px' }}>
            <div className="item-count-container" style={{ padding: '10px' }}>
              <span className="item-count">{`${trans('TOTAL')} (${userGroups.length})`}</span>
              <span className="group-list-subtitle">
                {trans('GROUPSHAVEBEENSORTEDBYALPHABETICALORDER')}
              </span>
            </div>
          </div>
          {isStaffAdmin ? (
            <div
              className="create-group-btn"
              onClick={() => onGroupModalActionClick(GroupModalActions.addGroup)}
            >
              <div className="create-group-icon">
                <AddIcon style={{ height: '18px' }} />
              </div>
              <span className="create-group-text"> {trans('CREATEGROUP_U')}</span>
            </div>
          ) : null}
        </div>
        <Spin spinning={loading} style={{ flex: 1 }}>
          <div
            className={`group-list ${!loading && sortedUserGroups.length === 0 ? 'group-list-adjust' : ''}`}
          >
            {!loading && sortedUserGroups.length === 0 ? (
              <div className="no-groups-found">
                <p>{trans('NOGROUPSCREATEDYETMSG')}</p>
              </div>
            ) : (
              sortedUserGroups.map((group, index) => (
                <ListItem
                  key={group.groupuuid}
                  record={group}
                  title={group.name}
                  count={group.invited_contacts ? group.invited_contacts.length : 0}
                  onActionClick={onActionClick}
                  members={getInviteContacts(group.invited_contacts)}
                />
              ))
            )}
          </div>
        </Spin>
      </div>
    </MainPage>
  );
};

GroupsList.propTypes = {
  parentBread: PropTypes.arrayOf(PropTypes.object),
  setShowGroupModal: PropTypes.func,
  onActionClick: PropTypes.func,
  onGroupModalActionClick: PropTypes.func,
};

export default GroupsList;
